import {Key} from 'react';
import {connect} from 'react-redux';

import {ViewerPanelId} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ActivityModel} from '../../../../../models/api/activityModel';
import {makeGetGroupHeaderActivities} from '../../../../../store/data/activities/activitiesCollapseSelectors';
import {getUserId} from '../../../../../store/data/teammates/teammatesSelectors';
import {
  collapseActivityViewerAction,
  expandActivityViewerAsyncAction,
} from '../../../../../store/panels/viewer/activity/activityViewerActions';
import {BasicGroupHeader} from './basicGroupHeader';

/*
 * Props.
 */

interface BasicGroupHeaderContainerProps {
  activities: ReadonlyArray<ActivityModel>;
  activityIndex: number;
  focusKey: Key | undefined;
  activityId: number;
  conversationId: number;
  panelId: ViewerPanelId;
}

/*
 * Selectors.
 */

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<BasicGroupHeaderContainerProps>()(() => {
  const getGroupHeaderActivities = makeGetGroupHeaderActivities();

  return {
    userId: getUserId,
    collapsedHeaderActivities: getGroupHeaderActivities,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<BasicGroupHeaderContainerProps>()((props) => ({
  onExpandClick: () => expandActivityViewerAsyncAction(props.panelId, props.activityId),
  onCollapseClick: () => collapseActivityViewerAction(props.panelId, props.activityId),
}));

export const BasicGroupHeaderContainer = connect(mapStateToProps, mapDispatchToProps)(BasicGroupHeader);
